module.exports = __webpack_public_path__ + "static/img/mechanism-6.6f2d804d.png";